'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AppBar = require('material-ui/AppBar');

var _AppBar2 = _interopRequireDefault(_AppBar);

var _Drawer = require('material-ui/Drawer');

var _Drawer2 = _interopRequireDefault(_Drawer);

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _arrowBack = require('material-ui/svg-icons/navigation/arrow-back');

var _arrowBack2 = _interopRequireDefault(_arrowBack);

var _svgIcons = require('material-ui/svg-icons');

var Icons = _interopRequireWildcard(_svgIcons);

var _List = require('material-ui/List');

var _Divider = require('material-ui/Divider');

var _Divider2 = _interopRequireDefault(_Divider);

var _DrawerHeader = require('../DrawerHeader/DrawerHeader');

var _DrawerHeader2 = _interopRequireDefault(_DrawerHeader);

var _reactIntl = require('react-intl');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TODO : eliminare dipendenze intl

var DrawerMenu = function (_React$Component) {
  _inherits(DrawerMenu, _React$Component);

  function DrawerMenu(props) {
    _classCallCheck(this, DrawerMenu);

    var _this = _possibleConstructorReturn(this, (DrawerMenu.__proto__ || Object.getPrototypeOf(DrawerMenu)).call(this, props));

    _this.state = { open: false };

    _this.listStyle = {
      paddingTop: '0px'
    };

    _this.appBarStyle = {
      position: 'fixed',
      top: 0,
      zIndex: 1101
    };

    _this.handleToggle = _this.handleToggle.bind(_this);
    _this.onRequestChange = _this.onRequestChange.bind(_this);
    _this.getChild = _this.getChild.bind(_this);
    return _this;
  }

  _createClass(DrawerMenu, [{
    key: 'onRequestChange',
    value: function onRequestChange(open) {
      this.setState({ open: open });
    }
  }, {
    key: 'getChild',
    value: function getChild(child) {
      var _this2 = this;

      if (child.type === 'Divider') {
        return _react2.default.createElement(_Divider2.default, { key: child.key });
      }
      var onClick = this.props.onClick;
      var messages = this.props.intl.messages;

      var getNestedItems = function getNestedItems() {
        var items = [];
        if (child.items) {
          for (var i in child.items) {
            items.push(_this2.getChild(child.items[i]));
          }
        }
        return items;
      };
      var handleTouch = function handleTouch() {
        if (child.route) {
          _this2.handleClose.call(_this2);
          onClick(child.route);
        }
      };
      var childProps = {
        key: child.key,
        primaryText: messages[child.text] || child.text || '',
        insetChildren: true,
        leftIcon: Icons[child.icon] ? _react2.default.createElement(Icons[child.icon]) : null,
        primaryTogglesNestedList: !child.route && !!child.items,
        nestedItems: getNestedItems(),
        onTouchTap: handleTouch
      };
      return _react2.default.createElement(_List.ListItem, childProps);
    }
  }, {
    key: 'handleToggle',
    value: function handleToggle() {
      this.setState({ open: !this.state.open });
    }
  }, {
    key: 'handleClose',
    value: function handleClose() {
      this.setState({ open: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          appBar = _props.appBar,
          menu = _props.menu,
          items = _props.items,
          children = _props.children,
          header = _props.header,
          navigateBack = _props.navigateBack;
      var messages = this.props.intl.messages;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_AppBar2.default, _extends({
          iconElementLeft: appBar.navigateBack ? _react2.default.createElement(
            _IconButton2.default,
            { onClick: navigateBack },
            _react2.default.createElement(_arrowBack2.default, null)
          ) : null,
          onLeftIconButtonTouchTap: this.handleToggle
        }, appBar, {
          title: messages[appBar.title] || appBar.title || '',
          style: this.appBarStyle
        })),
        _react2.default.createElement(
          _Drawer2.default,
          _extends({
            docked: false,
            open: this.state.open,
            onRequestChange: this.onRequestChange
          }, menu),
          _react2.default.createElement(
            _List.List,
            { style: this.listStyle },
            header ? _react2.default.createElement(_DrawerHeader2.default, header) : undefined,
            items ? items.map(this.getChild) : null,
            children
          )
        )
      );
    }
  }]);

  return DrawerMenu;
}(_react2.default.Component);

DrawerMenu.propTypes = {
  intl: _reactIntl.intlShape.isRequired,
  appBar: _react2.default.PropTypes.object,
  menu: _react2.default.PropTypes.object,
  header: _react2.default.PropTypes.object,
  items: _react2.default.PropTypes.array,
  children: _react2.default.PropTypes.array,
  onClick: _react2.default.PropTypes.func,
  navigateBack: _react2.default.PropTypes.func
};
exports.default = (0, _reactIntl.injectIntl)(DrawerMenu);


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Presentational components/DrawerMenu/DrawerMenu.js
 ** module id = 490
 ** module chunks = 0
 **/